// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 678 ? "component---src-pages-index-js" : chunkId) + "-" + {"678":"8029f58ba5beabcd3b24","731":"27efe64f1ff5a626b410","843":"f65c997c23c9496393e1"}[chunkId] + ".js";
};